import {Promotion} from '../../types/singleModelInterface'
import {isExpandablePromotion} from './isExpandablePromotion'

/**
 * Finds the promotion to open on landing in the showroom: the first one, in the
 * order shown on the page, set as open by default in the showroom in the
 * backend (`is_open_by_default_in_showroom`) that can be opened at all.
 *
 * @param promotions Promotions of the model, in the order shown on the page
 * @returns The promotion to open, `undefined` if there is none
 */
export function findPromotionOpenByDefaultInShowroom(
    promotions: Promotion[] | undefined
): Promotion | undefined {
    return promotions?.find(
        (promotion) =>
            promotion.is_open_by_default_in_showroom === true &&
            isExpandablePromotion(promotion)
    )
}
